import { Group } from "@mantine/core";
import { IconFile, IconX } from "@tabler/icons-react";
import React from "react";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";
import { IconButton } from "#components/atoms/IconButton/IconButton";
import { Tooltip } from "#components/atoms/Tooltip/Tooltip";

import { Text } from "../../atoms/Typographies/Text";
import { FileUploadFile } from "./FileUpload";
import classes from "./FileUploadRow.module.css";

type FileUploadRowProps = {
  file: FileUploadFile;
  onDelete: (hash: string) => void;
};

const FileUploadRow = ({ file, onDelete }: FileUploadRowProps) => {
  const { t } = useTranslation("components");

  return (
    <Group
      className={classes.row}
      gap={spacing[2]}
      align="center"
      wrap="nowrap"
      style={{ paddingTop: spacing[2.5], paddingBottom: spacing[2.5] }}
    >
      <IconFile size={16} color={colors.icon.secondary} strokeWidth={1.5} />
      <Text size="small" truncate style={{ flex: 1, minWidth: 0 }}>
        {file.name}
      </Text>
      {file.progress < 100 ? (
        <Text
          size="tiny"
          color={colors.text.secondaryDefault}
          textAlign="right"
          style={{ flexShrink: 0, fontFeatureSettings: '"lnum" 1, "pnum" 1' }}
        >
          {t("fileUpload.uploadProgress", { progress: file.progress })}
        </Text>
      ) : (
        <Tooltip label={t("fileUpload.delete")} position="bottom">
          <IconButton
            size="sm"
            variant="custom"
            aria-label={t("fileUpload.deleteFile", { name: file.name })}
            onClick={() => onDelete(file.hash)}
            classNames={{ root: classes.deleteButton }}
          >
            <IconX size={16} />
          </IconButton>
        </Tooltip>
      )}
    </Group>
  );
};

export { FileUploadRow };
